// ES6 CLASS ===========================================================================
class Tile1 {
  constructor(x, y, width, height, fill, date) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;
    this.fill = fill;
    this.date = date; // Add date property
  }

  draw(context) {
    context.fillStyle = this.fill;
    context.fillRect(this.x, this.y, this.width, this.height);
    
    // Set text properties and draw the date inside the tile with custom font styles
    context.fillStyle = "#fff"; // Text color
    context.font = "2rem 'Bebas Neue', system-ui"; // Custom font and size
    context.textAlign = "center";
    context.letterSpacing = "2px"; // Letter spacing
    context.fillText(this.date, this.x + this.width / 2, this.y + this.height / 2 + 5);
  }
}

// CONSTRUCTOR FUNCTION ===========================================================================
function Tile2(x, y, width, height, fill, date) {
  this.x = x;
  this.y = y;
  this.width = width;
  this.height = height;
  this.fill = fill;
  this.date = date; // Add date property
}

Tile2.prototype.draw = function(context) {
  context.fillStyle = this.fill;
  context.fillRect(this.x, this.y, this.width, this.height);

  // Set text properties and draw the date inside the tile with custom font styles
  context.fillStyle = "#fff"; // Text color
  context.font = "2rem 'Bebas Neue', system-ui"; // Custom font and size
  context.textAlign = "center";
  context.letterSpacing = "2px"; // Letter spacing
  context.fillText(this.date, this.x + this.width / 2, this.y + this.height / 2 + 5);
};

// FACTORY ===========================================================================
function createTile(x, y, width, height, fill, date) {  
  var tile = {
    x: x,
    y,
    width,
    height,
    fill,
    date, // Add date property
    draw(context) {
      context.fillStyle = this.fill;
      context.fillRect(this.x, this.y, this.width, this.height);

      // Set text properties and draw the date inside the tile with custom font styles
      context.fillStyle = "#fff"; // Text color
      context.font = "2rem 'Bebas Neue', system-ui"; // Custom font and size
      context.textBaseline = "middle"
      context.textAlign = "center";
      context.letterSpacing = "2px"; // Letter spacing
      context.fillText(this.date, this.x + this.width / 2, this.y + this.height / 2 - 0);

    }
  };
  return tile;
}

// DEMO ===========================================================================
var canvas = document.querySelector("#canvas");
var context = canvas.getContext("2d");

canvas.width = 800;
canvas.height = 800;

var rows = 4; // Four rows of tiles
var cols = 6; // Six tiles per row
var tileWidth = 100;
var tileHeight = 80;
var gutter = 10;
var padding = 10;

var row1 = [];
var row2 = [];
var row3 = [];
var row4 = []; // Fourth row

var x = padding;
var y = padding;

canvas.width = (padding * 2) + (tileWidth * cols) + (gutter * (cols - 1));
canvas.height = (padding * 2) + (tileHeight * rows) + (gutter * (rows - 1));

// Start dates from 2002
var startDate = 2002;

// Row1 using ES6 classes with different dates
for (var col = 0; col < cols; col++, x += tileWidth + gutter) {
  var date = startDate++; // Increment date starting from 2002
  var tile = new Tile1(x, y, tileWidth, tileHeight, "#5b0016", date);
  row1.push(tile);
}

x = padding;
y += tileHeight + gutter;

// Row2 using constructor function with different dates
for (var col = 0; col < cols; col++, x += tileWidth + gutter) {
  var date = startDate++; // Increment date
  var tile = new Tile2(x, y, tileWidth, tileHeight, "#7f0a1b", date);
  row2.unshift(tile);
}

x = padding;
y += tileHeight + gutter;

// Row3 using factory function with different dates
for (var col = 0; col < cols; col++, x += tileWidth + gutter) {
  var date = startDate++; // Increment date
  var tile = createTile(x, y, tileWidth, tileHeight, "#a00b21", date);
  row3.push(tile);  
}

x = padding;
y += tileHeight + gutter;

// Row4 using factory function with different dates
for (var col = 0; col < cols; col++, x += tileWidth + gutter) {
  var date = startDate++; // Increment date
  var tile = createTile(x, y, tileWidth, tileHeight, "#cd011b", date);
  row4.push(tile);  
}

// Combine row arrays into single array
var tiles = [].concat(row1, row2, row3, row4);

// Timeline animation using GSAP 3
var tl = gsap.timeline({ repeat: -1 });
tl.staggerTo(tiles, 1, {
  fill: "#717d96",
  x: "+=5",
  y: "+=5",
  width: "-=10",
  height: "-=10",
  repeat: 1,
  yoyo: true,
}, 0.1);

// GSAP Ticker
gsap.ticker.add(render);

// Render function
function render() {
  context.clearRect(0, 0, canvas.width, canvas.height);
  for (var i = 0; i < tiles.length; i++) {
    var tile = tiles[i];
    tile.draw(context);
  }
}

canvas.addEventListener("click", function(event) {
  var rect = canvas.getBoundingClientRect();
  var scaleX = canvas.width / rect.width; // Scale factor for X
  var scaleY = canvas.height / rect.height; // Scale factor for Y

  var mouseX = (event.clientX - rect.left) * scaleX;
  var mouseY = (event.clientY - rect.top) * scaleY;

  // Check if the click is within any tile
  tiles.forEach(tile => {
    if (mouseX >= tile.x && mouseX <= tile.x + tile.width &&
        mouseY >= tile.y && mouseY <= tile.y + tile.height) {
      toggleAccordion(tile.date); // Trigger accordion
    }
  });
});

// Function to toggle the accordion content based on the tile
function toggleAccordion(date) {
  var accordion = document.getElementById("accordion");

  // Check if content for this date already exists
  var existingContent = document.querySelector(`#content-${date}`);
  
  if (existingContent) {
    // If the content is already visible, hide it
    if (existingContent.style.display === "block") {
      existingContent.style.display = "none";
    } else {
     existingContent.style.display = "block";

// Scroll to the opened content
existingContent.scrollIntoView({
  behavior: "smooth",
  block: "start"
});
    }
  } else {
    // Otherwise, create new accordion content
    var newContent = document.querySelector(`#content-${date}`);

    // Ensure the content is visible
    newContent.style.display = "block";
  }

  // Add a click listener to the content itself to close it when clicked
  existingContent.addEventListener("click", function (event) {
    // Prevent the click event from bubbling up and affecting other elements
    event.stopPropagation();

    // Close the accordion content when it is clicked
    existingContent.style.display = "none";
  });
}
